import React from 'react'
import { validateDinnerTips } from '../actions'
import { useDispatch } from 'react-redux';

const ValidateDinnerTipsButton = () => {
    const dispatch = useDispatch();
 return <button onClick={() => dispatch(validateDinnerTips())}>Validate Dinner Tips</button>
 }

export default ValidateDinnerTipsButton